<template>
    <v-container fluid class="ma-0 pa-0">
        <kpi-table-simulations :table_data="table_data" :cdb="cdb"></kpi-table-simulations>


        <Browser :filters="Object.keys(kpi_filters_simulation_states).join('')" :searchFunc="filter_func" :cleanFunc="clean_filters" :fab="true">
            <template v-slot:inputs>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            autocomplete="off" 
                            label="Red neuronal" 
                            v-model="filters['current_model']" 
                            v-on:keyup.enter="filter_func"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </template>
        </Browser>


    </v-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import KpiTableSimulations from '../components/KpiTableSimulations.vue';
import Browser from '../components/Browser.vue';
import { vuexPrefix } from "../store/vuex_utils";

export default {
    components: {
        KpiTableSimulations,
        Browser,
    },
    props: {
        cdb: {
            type: Object,
            required: false,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            filters: {},
            table_data: [],
        };
    },
    computed: {
        ...mapFields('kpis', ['kpis_data', ]),
        ...mapFields('kpis', vuexPrefix('kpi_filters_', ['simulation_states'], 'kpi_filters.')),
        ...mapFields('documents', vuexPrefix('docs_', ['state'], 'documentListFiltersData2.')),
    },
    methods: {
        filter_func() {
            let that = this;
            this.kpi_filters_simulation_states = JSON.parse(JSON.stringify(this.filters));
            this.table_data = this.kpis_data.items;
            if (Object.keys(this.kpi_filters_simulation_states).length) {
                if (this.kpi_filters_simulation_states['current_model']) {
                    this.table_data = this.table_data.filter(function(item) {
                        return item[Object.keys(item)[0]].includes(that.kpi_filters_simulation_states['current_model']);       
                    });
                } 
            }
        },
        clean_filters() {
            this.filters = {};
            this.filter_func();
        }
    },
    mounted() {
        this.filter_func();
    }
};
</script>
<style scoped>
</style>